import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Checklist Maestra de Viaje Sin Pánico',
    subtitle: 'Salí con todo resuelto y evitá los errores que más caro le cuestan al viajero argentino',
    desc: 'Checklist de documentos, tecnología, equipaje de mano y valija. La checklist de 24 horas antes. El mini plan de salida sin estrés. Versión printable lista para usar.',
    value: '6.000'
  }, {
    id: 2,
    title: 'Guía Express de Frases Clave para Zafar',
    subtitle: 'Las frases exactas cuando no sabés qué decir y no podés quedarte congelado',
    desc: 'Las 20 frases más importantes en una sola página. Organizadas por situación: ayuda, transporte, comida, hotel, emergencia y bloqueo. Diseñada para abrir en segundos y resolver.',
    value: '6.000'
  }, {
    id: 3,
    title: 'Mapa Mental del Viajero Tranquilo',
    subtitle: 'Ordená tu cabeza antes del viaje y reemplazá ansiedad por claridad',
    desc: 'Los miedos reales del viajero argentino analizados y resueltos. Tabla si pasa esto / hago esto. Reprogramación mental rápida. Ritual de 5 minutos antes de salir. Hoja de enfoque completa.',
    value: '6.000'
  }, {
    id: 4,
    title: 'Plantillas Rápidas para Organizar tu Viaje',
    subtitle: 'Organizá todo en 10 minutos con plantillas simples',
    desc: 'Plantilla de datos importantes, presupuesto básico, día de llegada, ruta diaria, compras inteligentes, emergencia rápida y resumen del día. Versión printable incluida.',
    value: '6.000'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/80 border-y border-slate-800 relative overflow-hidden" data-id="element-16">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-purple-600/10 blur-[100px] rounded-full" data-id="element-18" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-600/10 blur-[100px] rounded-full" data-id="element-19" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-500/20 text-purple-400 mb-6" data-id="element-22">
            <Gift className="w-8 h-8" data-id="element-23" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-24">
            4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-purple-400 font-semibold" data-id="element-25">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-26">
          {bonuses.map((bonus, i) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-panel p-8 rounded-2xl border-purple-500/20 hover:border-purple-500/40 transition-colors group" data-id="element-27">
              <div className="flex items-start gap-4 mb-4" data-id="element-28">
                <div className="bg-purple-500/20 p-3 rounded-xl text-purple-400 group-hover:bg-purple-500 group-hover:text-white transition-colors" data-id="element-29">
                  <Gift className="w-6 h-6" data-id="element-30" />
                </div>
                <div data-id="element-31">
                  <div className="text-sm font-bold text-purple-400 mb-1" data-id="element-32">
                    Bono {bonus.id}
                  </div>
                  <h3 className="text-xl font-bold text-white leading-tight" data-id="element-33">
                    {bonus.title}
                  </h3>
                </div>
              </div>
              <p className="font-semibold text-slate-300 mb-4" data-id="element-34">
                {bonus.subtitle}
              </p>
              <p className="text-slate-400 text-sm leading-relaxed mb-6" data-id="element-35">
                {bonus.desc}
              </p>

              <div className="pt-4 border-t border-slate-700/50 flex items-center justify-between" data-id="element-36">
                <span className="text-slate-500 line-through text-sm" data-id="element-37">
                  Valor: ${bonus.value} ARS
                </span>
                <span className="font-bold text-green-400 text-lg" data-id="element-38">
                  → GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-r from-purple-900/50 to-blue-900/50 border border-purple-500/30 rounded-2xl p-6 text-center" data-id="element-39">
          <p className="text-lg text-slate-300 mb-1" data-id="element-40">Valor total bonos</p>
          <div className="flex items-center justify-center gap-3 text-2xl md:text-3xl font-bold" data-id="element-41">
            <span className="text-slate-500 line-through" data-id="element-42">$24.000 ARS</span>
            <span className="text-green-400" data-id="element-43">→ GRATIS con tu PackViajero</span>
          </div>
        </motion.div>
      </div>
    </section>;
}